import React, { useState } from "react";
import star from "../../assets/images/star.svg";
import emergencyDefault from '../../assets/images/people.svg';
import useCurrentUser from "hooks/useCurrentUser";
import { Link } from "react-router-dom";
import { paymnetService } from "services/payment.service";
import { FaPaypal } from "react-icons/fa";
import { toast } from "react-toastify";
import { emergencyService } from "services/emergency.service";

const MissingPerson = ({ activeTab, handleViewMore, emergencyData, setEmergencies }) => {
  const { user } = useCurrentUser();

  const [paidEmergencies, setPaidEmergencies] = useState([]);

  const handlePayNow = async (emergency) => {
    try {
      const response = await paymnetService.createCheckoutSession({ type: 'Emergency', id: emergency?._id });
      response?.data?.data?.url && window.open(response?.data?.data?.url, '_blank');
    } catch (err) {
      toast.error(err.data.message);
    }
  }


  const handleDeny = async (id) => {
    try {
      const response = await emergencyService.denyPayment(id)
      if (response?.data?.success) {
        toast.success(response?.data?.message);
        const updatedEmergencies = emergencyData?.emergencies?.map(item => {
          if (item?._id === id) {
            return response?.data?.data?.emergency;
          }
          return item;
        });

        setEmergencies({
          totalEmergencies: updatedEmergencies?.length,
          emergencies: updatedEmergencies
        })
      } else {
        toast.warning(response?.data?.message);
      }
    } catch (err) {
      toast.error(err.data.message);
    }
  }

  return (
    <>
      {emergencyData?.emergencies?.length > 0 ? (
        <>
          {emergencyData?.emergencies?.map((item, i) => {
            return (<div className="d-flex flex-wrap emergency-carrds gap-3 justify-content-between" key={item?._id}>
              <Link to={`/missingdetails/${item?._id}`}>
                <div className="d-flex align-items-center">
                  <div className="bg-circle me-3">
                    <img
                      alt="Missing Person"
                      src={`${user?.baseS3Url}${item?.missingPerson?.avatar || ""}`}
                      onError={(e) => {
                        e.currentTarget.src = emergencyDefault; // fallback image
                      }}
                      className="w-100 rounded"
                    />
                  </div>
                  <div>
                    <h4>{item?.missingPerson?.fullName}</h4>
                    <p className="mb-0">{item?.missingPerson?.gender}</p>
                  </div>
                </div>
              </Link>
              <div>

                {item?.paymentStatus === "Paid" || paidEmergencies.includes(item?._id) ? (
                  "Paid"
                ) : (
                  item?.paymentStatus === "UserDeny" ? (
                    "Denied"
                  ) : item?.isChargeRequestedByAdmin === true ? (
                    <div className="d-flex  gap-2">
                      <button
                        className="btn pay-btn blue-btn" onClick={() => handlePayNow(item)}>Pay Now</button>
                      <button
                        className="btn pay-btn blue-btn"
                        onClick={() => handleDeny(item?._id)}
                        disabled={paidEmergencies.includes(item?._id)}
                      >
                        Deny
                      </button>
                    </div>
                  ) : null
                )}
              </div>
            </div>)
          })}
        </>
      ) : (
        <div className="outer-white mission-div w-100 mx-auto">
          <div className="mt-2 ">
            <div className="disaster-card mx-auto text-center">
              <div className="alert-distaster mx-auto">
                <img src={star} alt="" />
              </div >
              <h2>No Items Available!</h2>
            </div >
          </div >
        </div >
      )}
      {emergencyData?.emergencies?.length < emergencyData?.totalEmergencies && <div className="text-center py-3" style={{ maxWidth: '300px', margin: "auto" }}>
        <button className=" blue-btnnn text-white border-0" onClick={handleViewMore}>
          View More
        </button>
      </div>}
    </>
  );
};

export default MissingPerson;
